import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { ImageSelectOption } from 'src/app/core/interfaces/image-select-option';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image-select-input',
  templateUrl: './image-select-input.component.html',
  styleUrls: ['./image-select-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ImageSelectInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ImageSelectInputComponent,
    },
  ],
})

export class ImageSelectInputComponent {
  public className = '';

  @Input()
  title = 'Select value...';

  @Input()
  description = '';

  @Input()
  isDisabled = false;

  @Input()
  filterByMemberType = 'INDIVIDUAL';

  @Input()
  public options!: Array<ImageSelectOption>;

  @Output()
  onClickCreateNew = new EventEmitter();

  public selectedSelectItem?: ImageSelectOption;

  constructor() {}

  ngOnInit(): void {}

  onChange = (imageSelectOption: ImageSelectOption | undefined) => {};

  onTouched = () => {};

  touched = false;

  disabled = false;

  onItemClick(imageSelectOption: ImageSelectOption) {
    this.markAsTouched();
    if (!this.disabled) {
      this.selectedSelectItem = imageSelectOption;
      this.onChange(this.selectedSelectItem);
    }
  }

  removeSelected(event: any) {
    event.stopPropagation();
    this.markAsTouched();
    this.selectedSelectItem = undefined;
    this.onChange(this.selectedSelectItem);
  }

  writeValue(imageSelectOption: ImageSelectOption) {
    this.selectedSelectItem = imageSelectOption;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.selectedSelectItemIsNotset()) {
      return null;
    }
    return null;
  }

  selectedSelectItemIsNotset() {
    return (
      this.selectedSelectItem === null ||
      this.selectedSelectItem === undefined ||
      this.selectedSelectItem.value === undefined ||
      this.selectedSelectItem.value === null
    );
  }

  imageLoadedEvent(event: any) {
    const image = event.target;
    image.classList.add('loaded');
  }

  imageLoadFailedEvent(event: any) {
    const image = event.target;
    console.log("Load failed");
    image.classList.add('load-failed');
  }

  getOptions(){
    console.log(this.filterByMemberType);

    if(this.filterByMemberType == ''){
      return this.options;
    }
    return this.options.filter((el) => el.type == this.filterByMemberType);
  }
}
